export const SET_PRIMARY_EMAIL_START = 'SET_PRIMARY_EMAIL_START';
export const SET_PRIMARY_EMAIL_SUCCESS = 'SET_PRIMARY_EMAIL_SUCCESS';
export const SET_PRIMARY_EMAIL_ERROR = 'SET_PRIMARY_EMAIL_ERROR';
export const SET_PRIMARY_EMAIL_END = 'SET_PRIMARY_EMAIL_END';
export const SET_PRIMARY_EMAIL_CLEAR = 'SET_PRIMARY_EMAIL_CLEAR';
